import React, { Component } from "react";
import "./Cart.scss";

export default class Cart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      date: "",
      number: "",

      showCheckout: false,
    };
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  createOrder = (e) => {
    e.preventDefault();
    const order = {
      name: this.state.name,
      email: this.state.email,
      date: this.state.date,
      number: this.state.number,
      cartItems: this.props.cartItems,
    };
    this.props.createOrder(order);
  };

  render() {
    const { cartItems } = this.props;
    return (
      <div className="cart__container">
        <div>
          {cartItems.length === 0 ? (
            <div className="cart__title"> Cart is Empty </div>
          ) : (
            <div className="cart__title">
              You have {cartItems.length} items in the cart
            </div>
          )}
        </div>
        <div>
          <div className="cart">
            <ul className="cart__items">
              {cartItems.map((item) => (
                <li key={item.id} className="cart__item">
                  {console.log(item.image)}
                  <div>
                    <img
                      src={item.image}
                      alt={item.title}
                      className="cart__img"
                    />
                  </div>
                  <div className="cart__description">
                    <div className="cart__left">
                      {item.price} x {item.count}{" "}
                      <p className="cart__item--title">{item.title}</p>
                    </div>
                    <button
                      className="cart__button"
                      onClick={() => this.props.removeFromCart(item)}
                    >
                      x
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          <div></div>
          {cartItems.length !== 0 && (
            <div>
              <div>
                <div className="cart__proceed">
                  <div className="cart__total">
                    Total: $
                    {cartItems.reduce((a, c) => a + c.price * c.count, 0)}
                  </div>
                  <button
                    onClick={() => {
                      this.setState({ showCheckout: true });
                    }}
                  >
                    Proceed
                  </button>
                </div>
              </div>
              {this.state.showCheckout && (
                <div>
                  <form className="cart__form" onSubmit={this.createOrder}>
                    <ul className="cart__list">
                      <li>
                        <label>Email</label>
                        <input
                          name="email"
                          type="email"
                          required
                          onChange={this.handleInput}
                        ></input>
                      </li>
                      <li>
                        <label>Name</label>
                        <input
                          name="name"
                          type="text"
                          required
                          onChange={this.handleInput}
                        ></input>
                      </li>
                      <li>
                        <label>Phone Number</label>
                        <input
                          name="number"
                          type="text"
                          required
                          onChange={this.handleInput}
                        ></input>
                      </li>
                      <li>
                        <label>Pickup Date</label>
                        <input
                          name="date"
                          type="date"
                          required
                          onChange={this.handleInput}
                        ></input>
                      </li>
                      <li>
                        <button type="submit">Checkout</button>
                      </li>
                    </ul>
                  </form>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}
